import { ref } from 'vue';

const canvasRef = ref(null);
let context;
const CANVAS_RESIZE_TIMOUT = 100;

export default function useCanvasInput(emit = () => {}) {
  let isDrawing = false;

  function getCanvasPos(evt) {
    const rect = canvasRef.value.getBoundingClientRect();
    const clientX = evt.clientX || evt.touches[0].clientX;
    const clientY = evt.clientY || evt.touches[0].clientY;
    return {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  }
  function isCanvasBlank() {
    const pixelBuffer = new Uint32Array(
      context.getImageData(0, 0, canvasRef.value.width, canvasRef.value.height).data.buffer,
    );

    return !pixelBuffer.some((color) => color !== 0);
  }

  function initContext() {
    context = canvasRef.value.getContext('2d', { willReadFrequently: true });
    return context;
  }

  function getCanvasContext() {
    return context;
  }

  function startDrawing(e) {
    isDrawing = true;
    context.beginPath();
    const { x, y } = getCanvasPos(e);
    context.moveTo(x, y);
  }

  function draw(e) {
    if (isDrawing) {
      const { x, y } = getCanvasPos(e);

      context.lineTo(x, y);
      context.stroke();
      emit('drawing');
    }
  }

  function stopDrawing() {
    isDrawing = false;
    if (!isCanvasBlank()) {
      emit('data', canvasRef.value.toDataURL());
    }
  }

  function clearCanvas() {
    if (canvasRef.value && context) {
      context.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
    }
    emit('clear');
  }

  function disableScrollingOnCanvasTouch(rootEl) {
    rootEl.addEventListener('touchstart', (e) => {
      if (e.target === canvasRef.value) {
        e.preventDefault();
      }
    }, false);
    rootEl.addEventListener('touchend', (e) => {
      if (e.target === canvasRef.value) {
        e.preventDefault();
      }
    }, false);
    rootEl.addEventListener('touchmove', (e) => {
      if (e.target === canvasRef.value) {
        e.preventDefault();
      }
    }, false);
  }

  function setCanvasSize() {
    const { clientWidth, clientHeight } = canvasRef.value.parentElement;
    canvasRef.value.width = clientWidth;
    canvasRef.value.height = clientHeight;
  }

  function touch2Mouse(e) {
    const theTouch = e.changedTouches[0];
    let mouseEv;

    switch (e.type) {
      case 'touchstart':
        mouseEv = 'mousedown';
        break;
      case 'touchend':
        mouseEv = 'mouseup';
        break;
      case 'touchmove':
        mouseEv = 'mousemove';
        break;
      default: return;
    }
    const mouseEvent = new MouseEvent(mouseEv, {
      screenX: theTouch.screenX,
      screenY: theTouch.screenY,
      clientX: theTouch.clientX,
      clientY: theTouch.clientY,
    });
    theTouch.target.dispatchEvent(mouseEvent);

    e.preventDefault();
  }

  function addTouchScreenSupport() {
    if ('ontouchstart' in document.documentElement) {
      canvasRef.value.ontouchstart = startDrawing;
      canvasRef.value.ontouchmove = draw;
      canvasRef.value.ontouchend = stopDrawing;
    } else {
      canvasRef.value.addEventListener('touchstart', touch2Mouse, true);
      canvasRef.value.addEventListener('touchmove', touch2Mouse, true);
      canvasRef.value.addEventListener('touchend', touch2Mouse, true);
    }
  }

  function subscribeEvents() {
    canvasRef.value.onmousedown = startDrawing;
    canvasRef.value.onmousemove = draw;
    canvasRef.value.onmouseup = stopDrawing;

    addTouchScreenSupport();
  }

  return {
    canvasRef,
    getCanvasContext,
    initContext,
    subscribeEvents,
    setCanvasSize,
    clearCanvas,
    disableScrollingOnCanvasTouch,
    CANVAS_RESIZE_TIMOUT,
  };
}
